import React, { Fragment } from 'react'
import { Typeahead, Highlighter } from 'react-bootstrap-typeahead'
import { append } from 'ramda'
import './style.scss'

export const Filter = ({ filter, text, option }) => {
  if (!filter) return null
  if (!option[filter]) return null

  const humanize = string => {
    return string
      .replace(/_/g, ' ')
      .trim()
      .replace(/\b[A-Z][a-z]+\b/g, word => word.toLowerCase())
      .replace(/^[a-z]/g, first => first.toUpperCase())
  }

  return (
    <div key={filter}>
      <small>
        {humanize(filter)}: <Highlighter search={text}>{option[filter]}</Highlighter>
      </small>
    </div>
  )
}

const Error = ({ error }) => {
  return <p className='inline-errors'>{error}</p>
}

export default class TypeaheadInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props
    }

    this._renderMenuItemChildren = this._renderMenuItemChildren.bind(this)
  }

  defaultMenuItemChildren(option, props) {
    const { filterBy } = this.state
    return (
      <Fragment>
        <Highlighter search={props.text}>
          {option.label}
        </Highlighter>
        { filterBy && filterBy.map((filter, idx) => <Filter key={idx} filter={filter} text={props.text} option={option} />) }
      </Fragment>
    )
  }

  _renderMenuItemChildren(option, props) {
    return (
      this.props.renderMenuItemChildren ? this.props.renderMenuItemChildren(option, props) : this.defaultMenuItemChildren(option, props)
    )
  }

  render() {
    const { options, disabled, selected, field_name, id, filterBy, errors, placeholder, class_name, autoFocus } = this.state
    const selectedOption = options.find(item => item.value === parseInt(selected))

    const handleOnChange = item => {
      let value = null
      if (item[0]) {
        value = item[0].value
      }

      this.setState({ selected: value, errors: null })
      if (this.props.onChange) {
        this.props.onChange(value)
      }
    }

    const handleOnInputChange = item => {
      if (this.props.onInputChange) {
        this.props.onInputChange(item)
      }
    }

    return (
      <Fragment>
        {selectedOption && <input type='hidden' value={selectedOption.value} name={field_name} />}
        <Typeahead
          options={options}
          placeholder={placeholder}
          id={id || 'visit-recipient'}
          renderMenuItemChildren={this._renderMenuItemChildren}
          filterBy={append('label', filterBy)}
          clearButton={!disabled}
          disabled={disabled}
          onChange={item => handleOnChange(item)}
          onInputChange={item => handleOnInputChange(item)}
          defaultInputValue={selectedOption?.label}
          className={class_name}
          inputProps={{ autoComplete: 'nope', autoFocus: autoFocus }}

        />
        { errors && <Error error={errors} /> }
      </Fragment>
    )
  }
}
